import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import {
  CreateEnterpriseShareDTO,
  CreateInsuredShareDTO,
  CreateMutuelleShareDTO,
  FileDTO,
} from '../models/dto';
import { PaginatedList, Share } from '../models/models';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ShareService {
  constructor(private apiService: ApiService) {}

  async createShareByMutuelle(data: CreateMutuelleShareDTO): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService.post<any>('/shares/mutuelles', data, true).subscribe({
        next: (res) => {
          resolve(res);
        },
        error: (res) => {
          reject(res?.error);
        },
      });
    });
  }

  async createShareByEnterprise(data: CreateInsuredShareDTO): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService.post<any>('/shares/enterprises', data, true).subscribe({
        next: (res) => {
          resolve(res);
        },
        error: (res) => {
          reject(res?.error);
        },
      });
    });
  }

  async getEnterpriseShares(
    uuid: string,
    params: any
  ): Promise<PaginatedList<Share>> {
    let route = '/enterprises/' + uuid + '/shares';
    if (params) {
      route += '?';
    }
    let firstParam = true;
    for (const [key, value] of Object.entries(params)) {
      route += firstParam ? key + '=' + value : '&' + key + '=' + value;
      firstParam = false;
    }
    return new Promise(async (resolve, reject) => {
      this.apiService.get<PaginatedList<Share>>(route, true).subscribe({
        next: (res) => {
          resolve(new PaginatedList<Share>(res, Share));
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  async getInsuredShares(id: string): Promise<Share[]> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<Share[]>('/members/' + id + '/shares', true)
        .subscribe({
          next: (res) => {
            resolve(res.map((r) => new Share(r)));
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async getShare(uuid: string): Promise<Share> {
    return new Promise(async (resolve, reject) => {
      this.apiService.get<any>('/shares/' + uuid, true).subscribe({
        next: (res) => {
          resolve(new Share(res));
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  async getShareRequest(uuid: string): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService.get<any>('/members/shares/' + uuid, true).subscribe({
        next: (res) => {
          resolve(res);
        },
        error: (res) => {
          console.log(res?.error);
          reject(res?.error);
        },
      });
    });
  }

  async archiveShare(uuid: string, archived: boolean): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .put<any>('/shares/' + uuid + '/archive', { archived }, true)
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  async downloadDocumentFromShare(
    shareUuid: string,
    documentUuid: string
  ): Promise<{ url: string }> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .get<{ url: string }>(
          '/shares/' +
            shareUuid +
            '/documents/' +
            documentUuid +
            '/download?token=' +
            ApiService.token,
          true
        )
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }

  replyToShare(
    uuid: string,
    data: { files: FileDTO[]; message: string; token: string }
  ): Promise<any> {
    return new Promise(async (resolve, reject) => {
      this.apiService
        .put<any>('/shares/' + uuid + '/reply', data, true)
        .subscribe({
          next: (res) => {
            resolve(res);
          },
          error: (res) => {
            console.log(res?.error);
            reject(res?.error);
          },
        });
    });
  }
}
